import { type ReactNode } from 'react';

/**
 * Known status presets — mirror HTHD admin Badge presets so a page that
 * passes `variant="confirmed"` doesn't need to be changed during the port.
 * Unknown variants render with the neutral preset.
 */
const PRESET_LABELS: Record<string, string> = {
  active: 'Active',
  confirmed: 'Confirmed',
  pending: 'Pending',
  checked_in: 'Checked In',
  escalated: 'Escalated',
  closed: 'Closed',
  overdue: 'Overdue',
  cancelled: 'Cancelled',
  completed: 'Completed',
  failed: 'Failed',
};

export interface BadgeProps {
  /** Status keyword (e.g. "active", "pending"). Drives both the preset color and default label. */
  readonly variant: string;
  readonly children?: ReactNode;
  readonly className?: string;
}

/**
 * Small status pill. Uses `ferro-badge ferro-badge--<variant>`; falls back to
 * a neutral preset if the variant isn't recognized in the customer-app CSS.
 */
export function Badge({ variant, children, className = '' }: BadgeProps): JSX.Element {
  const safeVariant = variant.toLowerCase().replace(/[^a-z0-9_-]/g, '-');
  const label = children ?? PRESET_LABELS[variant] ?? variant;
  const cls = `ferro-badge ferro-badge--${safeVariant}${className ? ` ${className}` : ''}`;
  return <span className={cls}>{label}</span>;
}
